import { DomainForm } from "src/api";
import { FieldsData } from "../types";
import { Step } from "@lib/shared/types";
import { useState, useMemo } from "react";
import { keyBy, mapValues } from "@lib/shared/lodash";
import { decodeFieldsFromText } from "../utils/decodeFieldsFromText";

export const useSteps = (
    form: DomainForm,
    fieldsState: FieldsData | null,
    singleQuestion?: boolean,
): { steps: Step[]; setSteps: (steps: Step[]) => void } => {
    const initialSteps = useMemo(() => {
        const stepsToUse = singleQuestion ? form.steps.slice(0, 1) : form.steps;

        return stepsToUse.map((step) => ({
            ...step,
            title: decodeFieldsFromText(step.title || "", fieldsState),
            fields: step.fields.map((field) => {
                return {
                    ...field,
                    meta: Array.isArray(field.meta)
                        ? mapValues(keyBy(field.meta, "key"), "value")
                        : field.meta,
                };
            }),
        }));
    }, [form.steps, fieldsState, singleQuestion]);

    const [steps, setSteps] = useState(initialSteps);
    return { steps, setSteps };
};
